import React from 'react'
import { faEnvelope, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Container, Row } from 'react-bootstrap'
// import VKIconSVG from './VKIconSVG'
// import InstagramIconSVG from './InstagramIconSVG'

const PageContainer: React.FC = ({ children }) => {
  return (
    <>
      <div style={{ height: '75px' }} />
      <Container>
        <Container fluid className='bg-white justify-content-start'>
          <div className='px-dynamic'>{children}</div>
          <div style={{ height: '75px' }} />
        </Container>
        <Container fluid>
          <Row className='px-dynamic'>
            <div className='spacer-40' />
            <div className='ml-md-auto grey' style={{ width: 'auto' }}>
              <div className='pb-2'>
                <a className='hidden-link' href='tel:+74732606060'>
                  <FontAwesomeIcon icon={faPhoneAlt} />
                  {' +7(473)260-60-60'}
                </a>
              </div>
              <div className='pb-2'>
                <a className='hidden-link' href='mailto:market@freedom-vrn.ru'>
                  <FontAwesomeIcon icon={faEnvelope} />
                  {' market@freedom-vrn.ru'}
                </a>
              </div>
              {/*<div className='pb-2'>
                <FontAwesomeIcon icon={faEnvelope} />
                {' 394030, г. Воронеж'}
              </div>
              <div className='pb-2'>ул. Плехановская, 22а</div>
              <div className='pb-2'>© АО ИК "Информсвязь-Черноземье"</div>
              <div className='pb-2'>1992 – 2022</div>
              <div className='pb-2 d-flex'>
                <a
                  data-link-ext='VK'
                  href='https://vk.com/freedomvrn'
                  rel='noreferrer'
                  target='_blank'
                  className='grey my-link'
                  style={{ marginRight: '0.5rem' }}
                >
                  <VKIconSVG />
                </a>
                <a
                  data-link-ext='IG'
                  href='https://www.instagram.com/freedom_vrn/'
                  rel='noreferrer'
                  target='_blank'
                  className='grey my-link'
                  style={{ marginRight: '0.5rem' }}
                >
                  <InstagramIconSVG />
                </a>
                <a
                  data-link-ext='TG'
                  href='https://t.me/FreedomConversationBot'
                  rel='noreferrer'
                  target='_blank'
                  className='grey my-link'
                  style={{ marginRight: '0.5rem' }}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                </a>
              </div>*/}
            </div>
            <div style={{ height: '130px' }} />
          </Row>
        </Container>
      </Container>
    </>
  )
}
export default PageContainer
